<div class="input-group">
    <span class="input-group-text pointer datePickerSpan" (click)="openPoupUP(content)">{{placeHolder}}</span>
  </div>
  
  <ng-template #content let-modal>
    <div class="modal-header">
      <h5 class="modal-title" id="modal-basic-title">Date Range</h5>
      <div type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
      </div>
    </div>
    <div class="modal-body">
      <form #userForm="ngForm">
        <div class="container-fluid">
          <div class="row">
            <ng-container *ngFor="let field of formData; let i = index">
              <div class="col-md-6 col-6">
                <div class="form-group" *ngIf="field">
                    <label [ngClass]="{'required' : field.required}">{{ field.label }}</label>
                    <div class="input-group">
                      <input class="form-control" [name]="field.name+index" [(ngModel)]="dateObj[field.name]" ngbDatepicker #d="ngbDatepicker" [required]="field.required" [minDate]="field.min" [maxDate]="field.max" placeholder="dd/mm/yyyy">
                      <div class="input-group-text customstyle" *ngIf="!field.readonly" (click)="d.toggle()">
                        <i class="bx bx-calendar"></i>
                      </div>
                    </div>
                  </div>
              </div>
            </ng-container>
          </div>
          <div class="row">
            <div class="col-md-12 mt-2 text-center">
              <button class="btn btn-outline-danger btn-sm mr-5" (click)="onClear()">Clear</button>
              <button class="btn btn-outline-success btn-sm" (click)="ngOnChanges()">Submit</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>